<template>
    <div class="container">
        <div class="row">
    <div class="col-md-4 order-md-2 mb-4">
      <h4 class="d-flex justify-content-between align-items-center mb-3">
        <span class="text-muted">{{ $t('menu.tu_carro') }}</span>
        <span class="badge badge-secondary badge-pill">{{cantidad}}</span>
      </h4>
      <ul class="list-group mb-3">
        <li v-for="item in lineas" :key="item.Id" class="list-group-item d-flex justify-content-between lh-condensed">
          <div>
            <h6 class="my-0">{{item.Nombre}}</h6>
            <small class="text-muted">{{item.Cantidad}}</small>
          </div>
          <span class="text-muted">{{(item.Precio)}}</span>
        </li>
        
        <li class="list-group-item d-flex justify-content-between">
          <span>Total</span>
          <strong>{{importeTotal}}</strong>
        </li>
      </ul>

      <form class="card p-2 d-none">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Promo code">
          <div class="input-group-append">
            <button type="submit" class="btn btn-secondary">Redeem</button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-8 order-md-1">
      <h4 class="mb-3">{{ $t('envio.direccion_envio') }}</h4>
      <form class="needs-validation" novalidate="" ref="formulario">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="firstName">{{ $t('envio.nombre') }}</label>
            <input type="text" class="form-control" id="firstName" placeholder="" value="" required="" v-model="nombre">
            <div class="invalid-feedback">
              {{ $t('envio.error_nombre') }}
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="lastName">{{ $t('envio.apellidos') }}</label>
            <input type="text" class="form-control" id="lastName" placeholder="" value="" required="" v-model="apellido1">
            <div class="invalid-feedback">
              {{ $t('envio.error_apellidos') }}
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="apellido2">{{ $t('envio.apellidos_2') }}</label>
            <input type="text" class="form-control" id="apellido2" placeholder="" value=""  v-model="apellido2">    
            <div class="invalid-feedback">
              {{ $t('envio.error_apellidos') }}
            </div>        
          </div>
        </div>

        <div class="mb-3">
          <label for="phone">{{ $t('envio.telefono') }} </label>
          <input type="phone" class="form-control" id="phone" placeholder="phone" v-model="telefono">
          <div class="invalid-feedback">
           {{ $t('envio.error_telefono') }}
          </div>
        </div>

        <div class="mb-3">
          <label for="email">Email</label>
          <input type="email" class="form-control" id="email" placeholder="you@example.com" required="required" v-model="email">
          <div class="invalid-feedback">
            {{ $t('envio.error_email') }}
          </div>
        </div>
        <div class="mb-3">
          <label for="opcion_envio">{{ $t('envio.opcion_envio') }} </label>
          <select  class="form-control" id="opcion_envio"  v-model="opcion_envio">
            <option value="1">{{ $t('envio.opcion_envio_domicilio') }}</option>
            <option value="2">{{ $t('envio.opcion_envio_recogida') }}</option>
          </select>
          
          <div class="invalid-feedback">
           {{ $t('envio.error_telefono') }}
          </div>
        </div>
        <div class="mb-3">
          <label for="address">{{ $t('envio.direccion') }}</label>
          <input type="text" class="form-control" id="address" placeholder="1234 Main St" required="" v-model="direccion">
          <div class="invalid-feedback">
            {{ $t('envio.error_direccion') }}
          </div>
        </div>

        <div class="mb-3">
          <label for="address2">{{ $t('envio.direccion_2') }} <span class="text-muted">(Optional)</span></label>
          <input type="text" class="form-control" id="address2" placeholder="Apartment or suite" v-model="extension">
        </div>

        <div class="row">
          <div class="col-md-5 mb-3">
            <label for="country">{{ $t('envio.pais') }}</label>
             <input type="text" class="form-control" id="pais" placeholder="Country" v-model="país" required>
            <div class="invalid-feedback">
              {{ $t('envio.error_pais') }}
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <label for="state">{{ $t('envio.provincia') }}</label>
            <input type="text" class="form-control" id="state" placeholder="State" v-model="provincia" required>            
            <div class="invalid-feedback">
             {{ $t('envio.error_provincia') }}
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <label for="zip">{{ $t('envio.codigo_postal') }}</label>
            <input type="text" class="form-control" id="zip" placeholder="" required="" v-model="cp">
            <div class="invalid-feedback">
              {{ $t('envio.error_codigo_postal') }}
            </div>
          </div>
        </div>
        <hr class="mb-4">
        <div class="custom-control custom-checkbox" style="display:none;visibility:hidden">
          <input type="checkbox" class="custom-control-input" id="same-address">
          <label class="custom-control-label" for="same-address">{{ $t('envio.mensaje_direccion_facturacion_misma') }}</label>
        </div>
        <div class="custom-control custom-checkbox" style="display:none;visibility:hidden">
          <input type="checkbox" class="custom-control-input" id="save-info">
          <label class="custom-control-label" for="save-info">Save this information for next time</label>
        </div>
        <hr class="mb-4">

        
        <button class="btn btn-primary btn-lg btn-block" type="submit" @click.prevent="hacerPedido">{{ $t('acciones.confirmar') }}</button>
      </form>
    </div>
  </div>
    </div>
</template>
<script>
import Servicios from "../services";
export default {
  data() {
    return {
      direccion: "",
      extension: "",
      nombre: "",
      apellido1: "",
      apellido2: "",
      telefono: "",
      email: "",
      pais: "",
      provincia: "",
      poblacion: "",
      cp: "",
      ident: "",
      opcion_envio: 2,
    };
  },
  computed: {
    lineas() {
      return this.$store.state.lineas;
    },
    cantidad() {
      return this.$store.getters["getTotal"];
    },
    importeTotal() {
      return this.$store.getters["getImporteTotal"];
    },
  },
  methods: {
    async hacerPedido(evt) {
      //Validación del Formulario (para que se muestren los mensajes localizados)
      let form = this.$refs["formulario"];
      let valido = form.checkValidity();
      form.classList.add("was-validated");
      //Fín validación

      console.log("Valido => ", valido);
      if (valido) {
        let pedido = {
          Nombre: this.nombre,
          Apellido1: this.apellido1,
          Apellido2: this.apellido2,
          Direccion: this.direccion,
          Email: this.email,
          Telefono: this.telefono,
          Provincia: this.provincia,
          Poblacion: this.poblacion,
          Pais: this.pais,
          CP: this.cp,
          Ident: "Ident",
          OpcionEnvio: this.opcion_envio,
        };
        pedido.Lineas = [];
        for (let i = 0; i < this.$store.state.lineas.length; i++) {
          const l = this.$store.state.lineas[i];
          pedido.Lineas.push({
            IdArticulo: l.Id,
            Cantidad: l.Cantidad,
          });
        }

        let res = await Servicios.Comprar(pedido);
        console.log("Respuesta comprar ", res, res.data, res.data.d);
        //Suponiendo que todo ha ido bien
        //Limpiar
        this.$store.commit("clearCart");
        
        //Ir a Confirmación (de momento dijimos que no hay pago)
        //15/06/2022 => Hoy Toni ha dicho que hay que redirigr al pago
        let {  UrlPagoTarjeta } = res.data.d;
        //Quitamos el paso por el Resguardo (que estaba de cuando no se cobraba el carro y pasamos directamente al cobro)
        window.location = UrlPagoTarjeta;
        // this.$router.push({
        //   name: "resguardo",
        //   params: { numero: ReferenciaCarro, url: UrlPagoTarjeta },
        // });
      }
    },
  },
  async mounted() {
    let resAxios = await Servicios.ObtenerInfoCliente();
    let infoCliente = resAxios.data.d;
    console.log("InfoCliente ==> ", infoCliente);
    if (infoCliente.HayCliente) {
      console.log("Hay Cliente", infoCliente.Nombre);
      this.nombre = infoCliente.Nombre;
      this.apellido1 = infoCliente.Apellido1;
      this.apellido2 = infoCliente.Apellido2;
      this.email = infoCliente.Email;
      this.direccion = infoCliente.Direccion;
      this.poblacion = infoCliente.Poblacion;
      this.provincia = infoCliente.Provincia;
      this.cp = infoCliente.CP;
    }
  },
};
</script>
